import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import profile from "../../assets/landing_page/Icons/Profile Page.svg";
const PlanCard = ({ id, name, score, description, note, members = [] }) => {
  const navigate = useNavigate();
  const handleCardClick = () => {
    navigate(`/home/AnalysisReport`, { state: { id, name } });
  };
  return (
    <Card 
  sx={{
    width: "100%",
    height: "90%",
    borderRadius: 2,
    border: "1px solid #E7E8EA",
    backgroundColor: "#EFF2F7",
    cursor: "pointer",
    transition: "transform 0.2s ease-in-out",
    "&:hover": { transform: "scale(1.05)" },
  }}
  onClick={handleCardClick}
>
  <CardContent sx={{ paddingBottom: "16px !important" }}>
    {/* Title with ellipsis */}
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Typography 
        fontSize={16} 
        fontWeight="bold" 
        sx={{
          whiteSpace: "nowrap", 
          overflow: "hidden", 
          textOverflow: "ellipsis", 
          maxWidth: "70%"  // Adjust width as needed
        }}
      >
        {name}
      </Typography>
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: 500,
          color: "#5A5A5A",
          backgroundColor: "#FFFFFF",
          padding: "2px 8px",
          borderRadius: "10px",
        }}
      >
        Analysis Report ⓘ
      </Typography>
    </Box>

    {/* Description */}
    <Typography 
  variant="body2" 
  color="textSecondary"
  sx={{
    whiteSpace: "nowrap", 
    overflow: "hidden", 
    textOverflow: "ellipsis", 
    maxWidth: "100%"  // Adjust width as needed
  }}
>
  {description}
</Typography>


    {/* Members List with Default Avatar */}
    {members.length > 0 && (
      <Box mt={1} display="flex" alignItems="center">
        {members.slice(0, 2).map((img, index) => (
          <img
            key={index}
            src={img || profile}  // Default avatar if img is missing
            alt="member"
            style={{
              width: 24,
              height: 24,
              borderRadius: "50%",
              marginRight: -8,
              border: "2px solid white",
              objectFit: "cover"
            }}
          />
        ))}
        {members.length > 2 && (
          <Typography variant="body2" sx={{ ml: 2, color: "gray" }}>
            +{members.length - 2}
          </Typography>
        )}
      </Box>
    )}

    {/* Score Section */}
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        padding: 2,
        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
        mt: 2,
        width: "calc(100% + 32px)",
        ml: "-16px",
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" fontWeight="bold">
          Analysis Score
        </Typography>
        <Typography variant="body2" fontWeight="bold" color="gray" marginRight={3}>
          {score}%
        </Typography>
      </Box>
      <Box
        sx={{
          width: "90%",
          height: 8,
          borderRadius: 4,
          backgroundColor: "#E7E8EA",
          mt: 1,
        }}
      >
        <Box
          sx={{
            width: `${score}%`,
            height: "100%",
            borderRadius: 4,
            backgroundColor:
              score <= 30 ? "red" :
                score <= 70 ? "blue" :
                  "green"
          }}
        />
      </Box>
      <Typography variant="body2" color="textSecondary">
       Note: {note} points passed
      </Typography>
    </Box>
  </CardContent>
</Card>

  );
};

export default PlanCard;
